import { useEffect } from 'react'
import useSession from '@/hooks/useSession'
import Spinner from '@/components/Spinner'
import { getSignInURL } from '@/util/helpers'

export default function SignoutPage() {
  const { session, endSession } = useSession()

  function handleLogout() {
    const signInURL = getSignInURL(session?.schoolSlug)
    endSession()
    window.location.href = signInURL
  }

  useEffect(() => {
    handleLogout()
  }, [])

  return (
    <>
      <title>Sign out - Book Blast by Books Are Fun</title>
      <div className='flex flex-col items-center justify-center py-56'>
        <div className='text-xl font-serif text-white mb-4 '> Signing out...</div>
        <Spinner />
      </div>
    </>
  )
}
